import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest } from '@angular/common/http';

import { ILoggedInUserViewModel } from '../../model/common.model';
import { EMPTY_GUID_VALUE } from '../../shared/properties/application.properties';
import { LocalStorageService } from '../../shared/services/local-storage.service';

// todo: The given implementation of HttpInterceptor will be added to the project a bit later,
// todo: as it may currently affect important aspects of the project.
// todo: Additionally, this implementation requires the support of the testing team.
/**
 * implementation of http interceptor
 */
@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private localStorageService: LocalStorageService) {}

  /**
   * http interceptor for application
   * @param request - http request
   * @param next - http handler
   */
  intercept(request, next) {
    request = this.setHeaders(request);

    return next.handle(request);
  }

  /**
   * set required headers for requests
   * @param request - http request
   */
  private setHeaders(request: HttpRequest<any>): HttpRequest<any> {
    const userDetails: ILoggedInUserViewModel = this.localStorageService.getCurrentUserDetails();
    const token: string = this.localStorageService.getAccessToken();

    let headers = {
      setHeaders: {
        Authorization: 'Bearer ' + token,
        RoleId: (userDetails && userDetails.roleId) ? userDetails.roleId : EMPTY_GUID_VALUE,
        BusinessUnitId: userDetails?.businessUnitId ? userDetails?.businessUnitId : EMPTY_GUID_VALUE,
      }
    };

    return request.clone(headers);
  }

}
